import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-777baf66")

_pushScopeId("data-v-777baf66")
const _hoisted_1 = { class: "AuthorQuotes" }
const _hoisted_2 = {
  key: 0,
  class: "quote-container"
}
const _hoisted_3 = { class: "author-quote__title" }
const _hoisted_4 = { class: "author-quote__container quote-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RandomQuoteButton = _resolveComponent("RandomQuoteButton")!
  const _component_QuoteContent = _resolveComponent("QuoteContent")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_RandomQuoteButton),
    (_ctx.quotes)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.author), 1),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.quotes, (quote) => {
              return (_openBlock(), _createBlock("div", {
                key: quote.id
              }, [
                _createVNode(_component_QuoteContent, {
                  "quote-text": quote.text
                }, null, 8, ["quote-text"])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})